<template>
  <div>
    <div class="home">
      <Header />
    </div>
    <RecentlyAnsweredQuestions />
    <HowWeWork />
    <AttorneyTestimonials />
    <BrowseAttorney />
    <FooterComponent />
  </div>
</template>


<script>
// Imports
import Header from './Header/Header.vue'
import RecentlyAnsweredQuestions from './Body/RecentlyAnsweredQuestions.vue'
import HowWeWork from './Body/HowWeWork.vue'
import AttorneyTestimonials from './Body/AttorneyTestimonials.vue'
import BrowseAttorney from './Body/BrowseAttorney.vue'
import FooterComponent from '../FooterComponent/FooterComponent.vue'
import {ref} from 'vue'
import {useHead} from '@unhead/vue'
export default {
  components: ({
    Header,
    RecentlyAnsweredQuestions,
    HowWeWork,
    AttorneyTestimonials,
    BrowseAttorney,
    FooterComponent,
  }),
  setup() {
    const metaData = ref({
      title: 'MeroAdda® | Free Q&A with Lawyers | Find a Lawyer',
      description: `MeroAdda.com, a Legal Technology platform in Nepal, that allows
      general users to search and find lawyers in Nepal and post legal questions
      anonymously and get answers from verified Lawyers in Nepal for Free.
      MeroAdda® also provides cheaper professional services for individuals
      and businesses.`,
      url: `${window.location.protocol}//${window.location.host}`,
    })
    useHead({
      title: metaData.value.title,
      meta: [
        {
          name: 'description',
          content: () => metaData.value.description,
        },
        {
          property: 'og:url',
          content: () => metaData.value.url,
        },
        {
          property: 'og:title',
          content: () => metaData.value.title,
        },
        {
          property: 'og:description',
          content: () => metaData.value.description,
        },
        {
          name: 'twitter:title',
          content: () => metaData.value.title,
        },
        {
          name: 'twitter:url',
          content: () => metaData.value.url,
        },
        {
          name: 'twitter:description',
          content: () => metaData.value.description,
        },
      ],
    })
    return {}
  },
}
</script>

